module.exports = __webpack_public_path__ + "Yfz3EKkuEAXohMTFW/RDC_RED_Logo_House.svg";